<template>
  <v-dialog width="1000" v-model="showAttachmentForm">
    <v-card>
      <v-card-title class="secondary white--text">
        <span> Credit Note {{ creditNoteNo }} </span>

        <v-spacer></v-spacer>

        <v-btn icon @click="resetForm(), (showAttachmentForm = false)">
          <v-icon class="white--text">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-2">
        <v-form
          ref="creditNoteAttachmentForm"
          v-if="showAttachmentForm"
          v-model="isValid"
        >
          <v-row class="my-0">
            <v-col cols="5" class="Form-Columns">
              <InputField
                type="text"
                label="Document Type *"
                required
                :rules="[(val) => !!val || 'Document type is Required!']"
                hide-details="auto"
                v-model="creditNoteDetails.document_type"
                :error-messages="formErrors.document_type"
                @input="delete formErrors.document_type"
              />
            </v-col>

            <v-col cols="4">
              <v-file-input
                label="Document *"
                accept="image/x-png,image/jpg,image/jpeg,application/pdf"
                :rules="[
                  (file) =>
                    !file ||
                    file.size < 2e6 ||
                    'File size should be less than 2 MB!',
                ]"
                outlined
                dense
                hide-details="auto"
                v-model="creditNoteDetails.attachment"
                :error-messages="formErrors.attachment"
                @change="checkFileFormat($event), delete formErrors.attachment"
              />
            </v-col>
            <v-col cols="3" class="d-flex justify-end">
              <v-btn
                color="primary"
                depressed
                :disabled="!isValid || !creditNoteDetails.attachment"
                @click="submitDocument"
              >
                Submit
              </v-btn>

              <v-btn
                class="ml-3"
                color="secondary"
                depressed
                @click="resetForm"
              >
                Reset
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-text>
        <AgGridVue
          style="width: 100%; height: calc(90vh - 320px)"
          class="ag-theme-alpine"
          id="myGrid"
          :columnDefs="headers"
          :context="context"
          @grid-ready="onGridReady"
          :defaultColDef="defaultColDef"
          :grid-options="gridOptions"
          :suppressDragLeaveHidesColumns="true"
          :rowData="allRowList"
        ></AgGridVue>

        <v-col v-if="totalItems > 0" cols="12" class="d-flex justify-end">
          <Pagination
            :pageNo="pageNo"
            :totalItems="totalItems"
            :pageSize="itemsPerPage"
            @itemsPerPageChange="itemsPerPageChanged"
            @prevPage="prevPage"
            @nextPage="nextPage"
          />
        </v-col>
      </v-card-text>

      <v-divider></v-divider>
    </v-card>
  </v-dialog>
</template>

<script>
import InputField from "@/components/FormBaseComponents/InputField.vue";
import MultiSelect from "@/components/FormBaseComponents/MultiSelect.vue";
import SelectField from "@/components/FormBaseComponents/SelectField.vue";
import { AgGridVue } from "ag-grid-vue";
import CreditNoteAttachmentButton from "@/components/AgGridComponents/CreditNoteAttachmentButton.vue";
import Pagination from "@/components/General/Pagination.vue";
import {
  generateBlobData,
  download,
  getFileNameFromUrl,
} from "@/utils/functions.js";
export default {
  components: {
    InputField,
    AgGridVue,
    SelectField,
    MultiSelect,
    CreditNoteAttachmentButton,
    Pagination,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    creditNoteID: {
      type: [Number, null],
      default: null,
    },
    creditNoteNo: {
      type: [String, null],
      default: null,
    },
  },
  watch: {
    value(val) {
      if (val) {
        if (this.editMode) {
        }
        this.getCreditNoteDocumentList();
      } else {
        this.resetForm();
      }
    },
  },
  computed: {
    showAttachmentForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    context() {
      return { parentComponent: this };
    },
    offset() {
      return this.itemsPerPage * (this.pageNo - 1);
    },
  },
  data() {
    return {
      formErrors: {},
      allRowList: [],
      isValid: true,
      generateBlobData: generateBlobData,
      download: download,
      isTextInput: false,
      pageNo: 1,
      itemsPerPage: 20,
      totalItems: 0,

      creditNoteDetails: {},
      defaultColDef: {
        resizable: true,
      },
      gridOptions: {
        onGridSizeChanged: () => {
          this.resizeGrid();
        },

        suppressRowClickSelection: true,
        suppressDragLeaveHidesColumns: true,
        enableCellTextSelection: true,
        tooltipShowDelay: 0,
        rowHeight: 35,
      },
      headers: [
        {
          headerName: "Document Type",
          field: "document_type",
          minWidth: 80,
        },
        {
          headerName: "Attachment",
          field: "attachment",
          minWidth: 120,
          valueGetter: (params) => {
            return params.context.parentComponent.getFileNameFromUrl(
              params.data.attachment
            );
          },
        },

        {
          headerName: "Actions",
          field: "actions",
          cellRendererFramework: "CreditNoteAttachmentButton",
          pinned: "right",
          minWidth: 100,
        },
      ],
    };
  },

  methods: {
    getFileNameFromUrl,

    checkFileFormat(event) {
      if (event) {
        const name = event.name;
        const lastDot = name.lastIndexOf(".");
        const ext = name.substring(lastDot + 1);
        let allowed = /(\jpg|\jpeg|\pdf|\png)$/i;
        if (!allowed.exec(ext)) {
          this.$nextTick(() => {
            this.creditNoteDetails.document = null;
            this.$bus.$emit("showToastMessage", {
              message: "This file format is not supported!",
              color: "error",
            });
          });
          return false;
        } else {
          return true;
        }
      }
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.resizeGrid();
    },
    resizeGrid() {
      if (this.gridOptions && "api" in this.gridOptions) {
        setTimeout(() => {
          this.gridOptions.api.sizeColumnsToFit();
        }, 100);
      }
    },
    itemsPerPageChanged(e) {
      this.pageNo = 1;
      this.itemsPerPage = e;
      this.getCreditNoteDocumentList();
    },
    prevPage() {
      this.pageNo--;
      this.getCreditNoteDocumentList();
    },
    nextPage() {
      this.pageNo++;
      this.getCreditNoteDocumentList();
    },
    viewItemDoc(data) {
      window.open(data.attachment, "_blank");
    },
    async downloadDoc(data) {
      this.$bus.$emit("showLoader", true);

      try {
        const response =
          await this.$api.customerInvoice.getDownloadDocumentsBlobObject(
            data.id
          );

        this.$bus.$emit("showLoader", false);

        const contentType = response.data.type;

        const fileExtension = response.data.type.split("/")[1];
        const fileName = this.getFileNameFromUrl(data.attachment);
        this.generateBlobData(
          response.data,
          `${this.getFileNameFromUrl(data.attachment).split(".")[0]}`,
          contentType
        );
      } catch (err) {
        console.error(err);
        this.$bus.$emit("showLoader", false);
      }
     
    },
    deleteDocument(data) {
      if (confirm(`Are you sure you want to delete ${data.document_type} ?`)) {
        this.$bus.$emit("showLoader", true);
        this.$api.customerInvoice
          .deleteCreditNoteDocument(data.id)
          .then((response) => {
            this.$bus.$emit("showLoader", false);
            this.$bus.$emit("showToastMessage", {
              message: "Document Deleted successfully!",
              color: "success",
            });

            this.getCreditNoteDocumentList();
          })
          .catch((err) => {
            console.error(err);
            this.$bus.$emit("showLoader", false);
          });
      }
    },

    submitDocument() {
      const formData = new FormData();
      formData.append("document_type", this.creditNoteDetails.document_type);

      formData.append("attachment", this.creditNoteDetails.attachment);

      if (this.creditNoteID) {
        formData.append("credit_note", this.creditNoteID);
      }

      this.$api.customerInvoice
        .creditNoteAttachment(formData)
        .then((res) => {
          this.$bus.$emit("showToastMessage", {
            message: "Document Uploaded successfully!",
            color: "success",
          });

          this.getCreditNoteDocumentList();

          this.resetForm();
        })
        .catch((err) => {
          this.$bus.$emit("showLoader", false);
          this.$bus.$emit("showToastMessage", {
            message: "Couldn't Create Document",
            color: "error",
          });
          this.formErrors = err.data;
        });
    },

    getCreditNoteDocumentList(params = {}) {
      this.$bus.$emit("showLoader", true);
      params = {
        offset: this.offset,
        limit: this.itemsPerPage,
        credit_note: this.creditNoteID,
        ...params,
        ...this.filters,
      };

      this.$api.customerInvoice
        .getCreditNoteAttachmentList(params)
        .then((res) => {
          this.allRowList = res.data;
          this.totalItems = res.count;

          this.$bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showLoader", false);
        });
    },

    resetForm() {
      if (this.$refs.creditNoteAttachmentForm) {
        this.$refs.creditNoteAttachmentForm.reset();
      }
      this.creditNoteDetails = {};
    },
  },
};
</script>
